export default "/images/pergamum.svg?a17c919c11824a8df5c4d66d2002b1fd";